<template lang="pug">
div(class="tw-h-full")
  v-container(fluid fill-height class="tw-h-full tw-content-start")
    v-row(dense)
      v-col(cols="3")
        div(class="tw-rounded-md tw-overflow-hidden")
          v-img(width="300px" :src="item.profile_photo_url")
      v-col(cols="9")
        v-row(dense)
          v-col
            div
              span(class="h3 tw-font-bold") {{ item.name }}
            div
              span(class=" caption") {{ item.email }}
        //v-row(no-gutters class="caption tw-pt-4")
          v-col(cols="auto" class="pr-2")
            v-icon(small class="pb-1") mdi-phone-classic
            span(class=" pl-1") {{ this.$faker().phone.phoneNumber() }}
        //v-row(no-gutters class="caption")
          v-col(cols="auto")
            v-icon(small class="pb-1") mdi-cellphone-iphone
            span(class=" pl-1") {{ this.$faker().phone.phoneNumber() }}
    //v-row(dense class="tw-pt-4")
      v-col
        span {{ this.$faker().lorem.paragraphs(2) }}
</template>
<script>
export default {
  data() {
    return {
      loading: false,
    };
  },
  watch: {
    id() {
      this.init();
    },
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    item() {
      return this.$store.getters['user/profile'];
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.loading = true;
      this.$store.dispatch('user/getUserProfile', this.id).then(() => {
        this.loading = false;
      });
    },
  },
};
</script>
